import React from 'react';
import { Icon } from '../Icon';
import pauseTrustCollageSrc from '../../assets/images/slide/pause-trust-collage.png';
import styles from './PauseSlideContentV6.css';

function PauseSlideContentV6() {
    return (
        <div className={styles.form}>
            <div className={styles.imageWrapper}>
                <img src={pauseTrustCollageSrc} alt='' className={styles.image} />
            </div>
            <div className={styles.content}>
                <div className={styles.headingSection}>
                    <h2 className={styles.heading}>You&apos;re doing something that matters</h2>
                    <p className={styles.description}>The big events are on record somewhere. The rest is not — the kitchen, the nickname, what your father actually sounded like. That exists in one place, and there is no backup.</p>
                </div>
                <div className={styles.testimonial}>
                    <div className={styles.testimonialHeader}>
                        <p className={styles.testimonialName}>Ruby, September</p>
                        <div className={styles.verifiedBadge}>
                            <Icon name='verifiedCheck' className={styles.verifiedIcon} />
                            <span>Verified</span>
                        </div>
                    </div>
                    <p className={styles.testimonialQuote}>“My kids live abroad, and I don&apos;t know when I&apos;ll see them next. Perhaps through my stories, we&apos;ll feel more connected.”</p>
                </div>
            </div>
        </div>
    );
}

export {
    PauseSlideContentV6
};
